module.exports = __webpack_public_path__ + "static/media/liveroom-withdraw-icon.03411918.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/liveroom-withdraw-icon.png
// module id = 2071
// module chunks = 6